import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/app/context/AuthContext';

export function SuperAdminRoute() {
    const { isSuperAdmin } = useAuth();

    if (!isSuperAdmin) {
        return <Navigate to="/projects" replace />;
    }

    return <Outlet />;
}
